import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-check-icon',
  imports: [],
  templateUrl: './check-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './check-icon.component.scss',
})
export class CheckIconComponent {}
